import { Injectable } from '@angular/core';
import { GroupMember } from '@schoolbelle/api/group-member';
import { Subject } from 'rxjs';

@Injectable({providedIn:'root'})
export class TableSearchService {
  onSelect = new Subject<GroupMember>();

}
